// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__YxRXL","modalButtons":"styles_modalButtons__BpPpe"};